import { render, staticRenderFns } from "./CreatorMessageDashboard.vue?vue&type=template&id=052f31cd&scoped=true"
import script from "./CreatorMessageDashboard.vue?vue&type=script&lang=js"
export * from "./CreatorMessageDashboard.vue?vue&type=script&lang=js"
import style0 from "./CreatorMessageDashboard.vue?vue&type=style&index=0&id=052f31cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052f31cd",
  null
  
)

export default component.exports